import { create } from 'zustand';
import type { GetCurrentUserOutputDTO } from '../shared/types/api/getCurrentUserOutputDTO';
import { sendClarityUserProperties } from '../shared/utils/clarity';

interface UserState {
  user: GetCurrentUserOutputDTO | null;
  isLoading: boolean;
  error: string | null;
  setUser: (user: GetCurrentUserOutputDTO) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()((set) => ({
  user: null,
  isLoading: false,
  error: null,
  setUser: (user) => {
    set({ user, error: null, isLoading: false });

    // Send user properties to Clarity
    if (user?.uid) {
      // Extract email and phone_number, handling both string and null types
      const email = user.email && typeof user.email === 'string' ? user.email : undefined;
      const phoneNumber =
        user.phone_number && typeof user.phone_number === 'string' ? user.phone_number : undefined;

      sendClarityUserProperties({
        uid: user.uid,
        full_name: user.full_name || undefined,
        email,
        phone_number: phoneNumber,
      });
    }
  },
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error, isLoading: false }),
  clearUser: () => set({ user: null, error: null, isLoading: false }),
}));
